import MenuContainerLayout from './MenuContainerLayout';

export default MenuContainerLayout;
